import request from "@/api/request";
import type {
    IChangePasswordReq,
    ILoginResData,
    IRegisterReq,
    IResetPasswordReq,
    ISignUpInvitationReq
} from "@/interfaces/user";
import type {IDefaultResponse} from "@/interfaces/general";
import statefulReq from "@/api/statefulReq";

export interface LoginData {
    email: string,
    password: string,
}

export function sanctumXsrf() {
    return statefulReq.get('/sanctum/csrf-cookie');
}

export async function loginApi(formData: LoginData) {
    const { data } = await statefulReq.post<IDefaultResponse<ILoginResData>>('/login', formData);
    return data
}

export async function logoutApi(all = false) {
    const { data } = await statefulReq.post<IDefaultResponse>(
        '/logout',
        {
            all_devices: all
        }
    );
    return data
}

export async function loginWithGoogle(token: string, invitation_token?: string) {
    const { data } = await statefulReq<IDefaultResponse<ILoginResData>>({
        url: "/login/google/callback",
        method: "post",
        data: {
            token: token,
            invitation_token: invitation_token
        },
    });
    return data
}

export async function signUpWithInvitation(formData: ISignUpInvitationReq) {
    const {data} = await statefulReq<IDefaultResponse<ILoginResData>>({
        url: "/register-by-invitation",
        method: "post",
        data: formData,
    });
    return data
}

export async function signUpRequest(formData: IRegisterReq) {
    const {data} = await request<IDefaultResponse<ILoginResData>>({
        url: "/register",
        method: "post",
        data: formData
    });
    return data
}

export async function generateTokenRequest(name: string, email: string) {
    const {data} = await request<IDefaultResponse>({
        url: "/register/token",
        method: "post",
        data: {
            email: email,
            name: name
        }
    });
    return data
}

export async function joinCompanyRequest(companyKey: string) {
    const { data } = await request<IDefaultResponse>({
        url: "/register/join-company",
        method: "post",
        data: {
            company_key: companyKey
        }
    });
    return data
}

export async function changePasswordRequest(formData: IChangePasswordReq) {
    const {data} = await request<IDefaultResponse>({
        url: "/change-password",
        method: "post",
        data: formData
    });

    return data
}

export async function forgotPasswordRequest(email: string) {
    const {data} = await request<any, IDefaultResponse>({
        url: "/forgot-password",
        method: "post",
        data: {
            email
        }
    })
    return data
}


export async function resetPasswordRequest(formData: IResetPasswordReq) {
    const {data} = await request<any, IDefaultResponse>({
        url: "/reset-password",
        method: "post",
        data: formData
    })

    return data
}